module.exports = __webpack_public_path__ + "img/google-play-badge-ja.9fe963d8.png";